<template>
  <el-dialog title="Alterar Valor do Aluguel" :visible.sync="visibility" @open="iniciar" :before-close="fechar" :close-on-click-modal="false" :modal-append-to-body="false" width="300px">
    <el-form ref="form" :model="aluguelRecuperado" :rules="validacao" size="small" label-position="top" hide-required-asterisk	:show-message="false" style="padding:0;">

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="Aluguel">
            <el-input v-model="aluguelRecuperado.idNaImobiliaria" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="Valor">
            <div class="el-input el-input--small">
              <money auto-complete="off" v-model="aluguelRecuperado.valor" v-bind="money" class="el-input__inner"/>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Mês série" prop="primeiroMesSerie">
            <el-input v-model="aluguelRecuperado.primeiroMesSerie" v-mask="'###'"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-checkbox v-model="aluguelRecuperado.somenteMesSerieSelecionado" label="Somente para o mês selecionado"></el-checkbox>
        </el-col>
      </el-row>

    </el-form>
    <span slot="footer">
      <el-button @click="alterarValorHandler" type="primary" size="small" round class="btn-box-shadow">Alterar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import { Money } from "v-money";

export default {
  components:{
    Money
  },
  props: {
    aluguel: Object,
    visibility: Boolean
  },
  data() {
    return {
      aluguelRecuperado: {},

      validacao: {
        primeiroMesSerie: [{ required: true }]
      },
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },
    }
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('alugueisContratosStore', [
      'alterarValorAluguel'
    ]),
    iniciar() {
      this.aluguelRecuperado = {
        id: this.aluguel.id,
        idNaImobiliaria: this.aluguel.idNaImobiliaria,
        somenteMesSerieSelecionado: false,
        taxaAdministracaoComplementar: false
      }
    },

    alterarValorHandler(){
      
      this.$refs["form"].validate((valid) => {
        if(valid){
        this.$confirm("Novos recibos serão gerados e você precisará realizar uma nova remessa. Deseja continuar?", "Atenção", {
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
          type: "warning"
        }).then(() => {
          this.showLoading();
          this.alterarValorAluguel(this.aluguelRecuperado)
          .then((resultado) => {
            this.hideLoading();
            switch(resultado.status) {
              case "SUCESSO":
                this.$message.success(resultado.mensagem);
                this.fechar();
                break;
              default:
                this.$message.warning(resultado.mensagem);
            }
            this.fechar();
          }).catch(() => {
            this.$message.error("Não foi possível conectar-se ao servidor");
            this.hideLoading();
            this.fechar();
          });
          return;
        }).catch(() => {
          this.fechar();
        });
        } else { this.$message.warning("Insira os dados obrigatórios.") }
      });
    },
    fechar() {
      this.$emit('close');
    }, 
  }
}
</script>